import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../config/apiClients";
import { buildUrlWithParams } from "../../../utils/helpers/common";
import { queryParams } from "../../../utils/interface";
import { AdminAuditLogsState } from "../../types";

const initialState: AdminAuditLogsState = {
  isLoading: false,
  auditLogs: [],
  pagination: { totalItems: 0, currentPage: 1, totalPages: 1, hasNextPage: false },
  error: null,
};

export const getAdminAuditLogs = createAsyncThunk(
  "/auditLogs/getAll",
  async (params: queryParams, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get(buildUrlWithParams("auditLogs/getAll", params));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: "Failed to Fetch Audit Logs" });
    }
  }
);

const auditLogsSlice = createSlice({
  name: "auditLogs",
  initialState,
  reducers: {
    clearAdminAuditLogs: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(getAdminAuditLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAdminAuditLogs.fulfilled, (state, action) => {
        const auditLogPage = action.payload.payload;
        state.isLoading = false;
        state.auditLogs = auditLogPage?.auditLogs ?? [];
        state.pagination = {
          totalItems: auditLogPage?.totalItems ?? 0,
          currentPage: auditLogPage?.page ?? 1,
          totalPages: auditLogPage?.totalPages ?? 1,
          hasNextPage: auditLogPage?.hasNextPage ?? false,
        };
      })
      .addCase(getAdminAuditLogs.rejected, (state, action) => {
        const rejection = action.payload as { message?: string } | undefined;
        state.isLoading = false;
        state.auditLogs = [];
        state.error = rejection?.message ?? "Failed to Fetch Audit Logs";
      });
  },
});

export const { clearAdminAuditLogs } = auditLogsSlice.actions;
export default auditLogsSlice.reducer;
